import { Box, IconButton, InputAdornment, Link, Typography } from '@mui/material';
import { CustomImgBox, CustomStack, LoginBox, LoginContainer, LoginTextField } from '@components/Styles/CommonStyle';
import { useEffect, useState } from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import { CustomButton } from '@components/Styles/ButtonStyle';
import CustomCheckBox from '@components/common/Input/CustomCheckBox';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import api from '@api/axios';
import logoBrick from '@assets/images/logo/logo_brick.svg';
import { theme } from '@components/Styles/theme';
import { useDialog } from '@context/DialogContext';
import { useLoading } from '@context/LoadingContext';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const navigate = useNavigate();
  const { showDialog } = useDialog();
  const { showLoading, hideLoading } = useLoading();

  const [userId, setUserId] = useState(localStorage.getItem('userId') || '');
  const [password, setPassword] = useState('');
  const [isSaveId, setIsSaveId] = useState(localStorage.getItem('userId') ? true : false);

  const onConfirm = (e) => {
    e.preventDefault();
    console.log(userId);
    console.log(password);

    const data = { user_id: userId, password: password };

    showLoading();

    api
      .post('/api/auth/login', data)
      .then((res) => {
        if (res.status === 200 && res.data.token) {
          localStorage.setItem('token', res.data.token);
          onSaveId();
          navigate('/project/projectList');
        }
      })
      .catch((err) => {
        console.log('Login :: err');
        console.log(err);

        const message = err.response.data.message ? err.response.data.message : '아이디/비밀번호를 확인해주세요.';

        // 로그인 실패 시 모달 표시
        showDialog({ title: '로그인 실패', message: message });
      })
      .finally(() => {
        hideLoading();
      });
  };

  const onNotice = () => {
    const message = () => {
      return (
        <>
          <Typography>아이디와 비밀번호를 잊은 경우</Typography>
          <Typography>시스템관리자에게 문의 바랍니다.</Typography>
          <Typography>시스템관리자 : -</Typography>
        </>
      );
    };

    showDialog({ title: '안내', message: message() });
  };

  const onSaveId = () => {
    if (isSaveId) {
      localStorage.setItem('userId', userId);
    } else {
      localStorage.removeItem('userId');
    }
  };

  useEffect(() => {
    if (localStorage.getItem('token')) {
      navigate('/project/projectList');
    }
  }, []);

  return (
    <LoginContainer component="form">
      <LoginBox>
        <Typography align="center" sx={{ ...theme.typography.h1, mb: 4 }}>
          사업 관리 시스템
        </Typography>

        <LoginTextField
          placeholder="아이디를 입력하세요"
          required
          name="id"
          autoComplete="id"
          autoFocus
          value={userId}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PersonOutlineRoundedIcon />
              </InputAdornment>
            ),
            endAdornment: userId && (
              <InputAdornment position="end">
                <IconButton onClick={() => setUserId('')} edge="end" size="small">
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          onChange={(e) => {
            setUserId(e.target.value);
          }}
        />
        <LoginTextField
          placeholder="비밀번호를 입력하세요"
          type="password"
          required
          name="password"
          autoComplete="current-password"
          value={password}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockOutlinedIcon />
              </InputAdornment>
            ),
            endAdornment: password && (
              <InputAdornment position="end">
                <IconButton onClick={() => setPassword('')} edge="end" size="small">
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          onChange={(e) => {
            setPassword(e.target.value);
          }}
        />

        <CustomStack justifyContent="spaceBetween">
          <Box>
            <CustomCheckBox
              size="small"
              checked={isSaveId}
              onChange={(e) => setIsSaveId(e.target.checked)}
              label="아이디 저장"
            />
          </Box>
          <Box>
            <Link onClick={onNotice}>아이디 | 비밀번호 찾기</Link>
            {/* <Link onClick={onNotice}>비밀번호 찾기</Link> */}
          </Box>
        </CustomStack>

        <CustomButton login="true" type="submit" size="custom" height="56px" sx={{ mt: 4 }} onClick={onConfirm}>
          로그인
        </CustomButton>

        <CustomStack justifyContent="center" sx={{ mt: 4, gap: 2 }}>
          <CustomImgBox src={logoBrick} alt="브릭 로고" />
          <Typography sx={{ ...theme.typography.body1, pt: 0.25, gap: 2, color: '#767676' }}>주식회사 브릭</Typography>
        </CustomStack>
      </LoginBox>
    </LoginContainer>
  );
};

export default Login;
